import React, { AriaAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import { getUserAvatarSrc, isGroup } from '../../../User/helpers';
import AvatarImage from '../../AvatarImage';

export interface Props {
  user?: PapiUser;
  size: number;
  className?: string;
  enableLazyLoad?: boolean;
  'aria-hidden'?: AriaAttributes['aria-hidden'];
}

const BasicUserAvatar: React.FC<Props> = ({
  user,
  size: height,
  className,
  'aria-hidden': ariaHidden,
  enableLazyLoad = true,
}) => {
  const { t } = useTranslation();
  const imgSrc = getUserAvatarSrc(user) ?? undefined;
  const isGroupAvatar = isGroup(user);
  const width = user && isGroupAvatar ? 2 * height : height;

  return (
    <AvatarImage
      isGroup={isGroupAvatar}
      width={width}
      height={height}
      src={imgSrc}
      className={className}
      alt={
        ariaHidden === 'true'
          ? ''
          : t('avatar.alt', {
              username: user?.username || t('avatar.unknownUser'),
            })
      }
      aria-hidden={ariaHidden}
      enableLazyLoad={enableLazyLoad}
      userId={user?.userId}
    />
  );
};
BasicUserAvatar.displayName = 'BasicUserAvatar';

export default BasicUserAvatar;
